import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { StatusTagVariant } from '../consolidatedReportModel';
import { pdfStyles, statusTagStyles } from './pdfTheme';

export const PdfCard: React.FC<{ title: string; children: React.ReactNode }> = ({
  title,
  children
}) => (
  <View style={pdfStyles.card}>
    <Text style={pdfStyles.cardTitle}>{title}</Text>
    {children}
  </View>
);

export const PdfKeyValue: React.FC<{ label: string; value: string }> = ({ label, value }) => (
  <View style={pdfStyles.bookingKvRow}>
    <Text wrap={false} style={pdfStyles.bookingKvKey}>
      {label}
    </Text>
    <Text style={pdfStyles.bookingKvValue}>{value}</Text>
  </View>
);

export const PdfStatusTag: React.FC<{
  label: string;
  variant: StatusTagVariant;
  /** System header tags use a narrower max width so the pill does not bleed into notes. */
  context?: 'system' | 'row';
}> = ({ label, variant, context = 'row' }) => {
  const palette = statusTagStyles[variant];
  const wrapStyle =
    context === 'system' ? pdfStyles.systemStatusTagWrap : pdfStyles.statusTagWrap;

  const textStyle =
    context === 'system' ? pdfStyles.systemStatusTagText : pdfStyles.statusTagText;

  return (
    <View style={[wrapStyle, { backgroundColor: palette.backgroundColor }]}>
      <Text style={[textStyle, { color: palette.color }]}>{label}</Text>
    </View>
  );
};

export const PdfFieldBlock: React.FC<{ label: string; value: string }> = ({ label, value }) => (
  <View style={pdfStyles.notesStackItem}>
    <Text style={pdfStyles.fieldLabel}>{label}</Text>
    <Text style={pdfStyles.bodyText}>{value}</Text>
  </View>
);
